
const digest = '13fe553350f886e1b8b8bd61872ef00ba3bfa448aebcfb55090ba480c7146b26';
const classes = {"wrapper":"_wrapper_10s0m_1"};
const css = `._wrapper_10s0m_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  